import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

/**
 * Binds to the global GA script and reports any SPA page changes.
 */
const useTracking = () => {
  const location = useLocation()

  // GA binding method.
  window.dataLayer = window.dataLayer || []

  function gtag() {
    window.dataLayer.push(arguments)
  }

  // Watch for changes and report them.
  useEffect(() => {
    gtag('set', 'page_path', location?.pathname + location.search)
    gtag('event', 'page_view')
  }, [location])
}

export const WithAnalyticsTracking = () => {
  useTracking()
  return <Outlet />
}
